export default __webpack_public_path__ + "static/logo_color-080f3373baa67aec5c65d3f02c03e14d.svg";